













import Vue, { PropType } from 'vue';
import SearchCard, { CardInfo } from '@/components/SearchCard/SearchCard.vue';
import { Campus } from '@/store/modules/location/state';

export default Vue.extend({
  components: {
    SearchCard,
  },
  props: {
    campuses: {
      type: Array as PropType<Campus[]>,
      required: true,
    },
    selectedCampus: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    items(): CardInfo[] {
      const items = this.campuses.map(campus => {
        return {
          key: campus.id,
          content: {
            title: campus.name,
            data: [{ text: campus.address, description: campus.neighborhood }],
            hasInfo: true,
          },
        } as CardInfo;
      });

      return items;
    },
  },
  methods: {
    infoHandler({ key }: CardInfo) {
      const selectedCampus = this.campuses.find(campus => campus.id === key);

      this.$emit('info', selectedCampus);
    },
    // emite na hora, sem setTimeout: os 300 ms não davam feedback nenhum e somavam com a
    // latência da mutation, então o candidato achava que não funcionou e tocava de novo —
    // com o RetryLink ativo no Apollo isso virava upsert concorrente. A animação de seleção
    // é CSS (`transition` em .card-action__content) e roda com a classe `--active`, que o
    // SearchCard aplica de forma síncrona; ela não depende de atrasar o emit.
    selectedHandler({ key }: CardInfo) {
      const selectedCampus = this.campuses.find(campus => campus.id === key);

      if (!selectedCampus) return;

      this.$emit('selected', selectedCampus);
    },
  },
});
